/**
 * Available HeroBanner header text block placement options.
 *
 * Defines the vertical placement of the header text block within the banner header area.
 * @public
 * @since 2.23.0
 */
enum HeroBannerHeaderBlockPlacement {
	/**
	 * Places the header text block at the top of the header area.
	 * @public
	 */
	Top = "Top",

	/**
	 * Places the header text block at the bottom of the header area.
	 * @public
	 */
	Bottom = "Bottom"
}

export default HeroBannerHeaderBlockPlacement;
